// @flow
import React from "react"
import { compose, withHandlers, type HOC } from "recompose"
import withConnect from "hoc/withConnect"
import CustomComponent from "modals/CustomComponent"
import { openModal } from "data/modals/actions"
import { filter } from "data/search/actions"
import type { SearchParams } from "data/search/types"
import type { Location, ProductGroup } from "data/app/types"
import { chooseGeolocation, chooseProductGroups } from "data/app/actions"
import { formatLocation, formatProductGroupFilter } from "data/app/formatters"
import FilterInput from "searchFilters/Shared/FilterInput"
import LocationFilter from "searchFilters/FilterComponents/LocationFilter"
import PassportFilter from "searchFilters/FilterComponents/PassportFilter"
import ProductGroupFilter from "searchFilters/FilterComponents/ProductGroupFilter"

const AllActivityFilters = ({
  geolocation,
  productGroups,
  handlePickLocation,
  handlePickProductGroup,
  handlePickPassport,
  chooseGeolocation,
  params,
  noPassport = false,
}) => (
  <React.Fragment>
    {handlePickProductGroup && (
      <FilterInput
        placeholder="Type"
        value={productGroups}
        formatter={formatProductGroupFilter("Type")}
        onClick={handlePickProductGroup}
      />
    )}
    {chooseGeolocation && (
      <FilterInput
        placeholder="Location"
        value={geolocation}
        formatter={formatLocation}
        onClick={handlePickLocation}
      />
    )}
    {!noPassport &&
      <FilterInput
        placeholder="Passport"
        value={params.discountId}
        formatter={() => "Passport"}
        onClick={handlePickPassport}
      />
     }
  </React.Fragment>
)

type Outter = {|
  geolocation: ?Location[],
  productGroups: ?ProductGroup[],
  chooseGeolocation?: typeof chooseGeolocation,
  chooseProductGroups: typeof chooseProductGroups,
  filter: typeof filter,
  params: SearchParams,
  noPassport: boolean,
|}

const enhancer: HOC<*, Outter> = compose(
  withConnect(() => ({}), { openModal }),
  withHandlers({
    handlePickLocation: props => () =>
      props.chooseGeolocation && props.openModal(CustomComponent, {
        title: "Location",
        component: LocationFilter,
        onChange: props.chooseGeolocation,
      }),
    handlePickProductGroup: props => () =>
      props.chooseProductGroups && props.openModal(CustomComponent, {
        title: "Type",
        component: ProductGroupFilter,
        onChange: props.chooseProductGroups,
        value: props.productGroups,
      }),
    handlePickPassport: props => () =>
      props.openModal(CustomComponent, {
        title: "Passport",
        component: PassportFilter,
        onChange: props.filter,
      }),
  }),
)

export default enhancer(AllActivityFilters)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainFilter/MobileFilters/AllActivityFilters.js